import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import { FormField, FormComponent, rules } from 'Common/components/Form'
import { Popconfirm, Alert, message, Row, Col, Upload, Avatar, Space, Card, Tooltip } from 'antd';
import { __error } from 'Common/scripts/consoleHelper'
import axios from 'axios'
import arrayMutators from 'final-form-arrays'
import { FieldArray } from 'react-final-form-arrays'
import Button, { DeleteButton } from './Button';
import Icon from './Icon';
import DevBlock from './DevBlock';
import { Image } from './Image';
import { sleep } from 'Common/scripts/Functions';
import { loader } from 'graphql.macro';
import { useLazyQuery, useMutation } from '@apollo/client';
import { verifyRole } from 'Common/scripts/Security';

const FILE_LIMIT = 6;
const img_fallback = `data:image/png;base64,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`

// admin/src/Graphql/InfoPages/delete_infoPage_Attachment.graphql
const DEL_ATTACHMENT = loader('src/Graphql/InfoPages/delete_infoPage_Attachment.graphql');

export default function InfoPageGallery({ page_id, attachments }) {
    const [attachmentsArray, set_attachmentsArray] = useState(null)
    const [busy, setBusy] = useState(false)

    const [delete_infoPage_Attachment, del_details] = useMutation(DEL_ATTACHMENT);

    useEffect(() => {
        set_attachmentsArray(attachments)
    }, [attachments])


    const onSubmit = async(values) => {
        var upload_results = await handleUpload(values.fileList, page_id).catch(err => {
            console.log(__error("ERROR: ", err));
            return { error: { message: 'Unable to complete upload request' } }
        });
        if (upload_results) set_attachmentsArray(upload_results?.data?.attachments)

        return 'reset';
    }

    const handleUpload = async (fileList, _id) => {
        if (!fileList || fileList.length < 1) return; // { error: { message: "No file to upload!!" } }
        if (fileList.length > FILE_LIMIT) return { error: { message: `You can upload max of ${FILE_LIMIT} files only!` } }
        if (!_id) return { error: { message: `Missing upload ID` } }

        const hide = message.loading('Uploading..', 0);

        const formData = new FormData();
        formData.append('action', "info_page.attachments");
        formData.append('info_page_id', _id);
        fileList.forEach(file => {
            formData.append('files[]', file);
        });

        const results = await axios.post(process.env.REACT_APP_API_URL + '/info_page_upload/upload', formData)
            .then(({ data }) => (data))
            .catch(function (error) {
                console.log(__error("Error: "), JSON.stringify(error, 0, 2));
                return { error: { message: "Upload request fail!" } };
            });

        hide();
        if (results.error) {
            message.error(results.error.message)
            return false;
        }
        message.success("Upload Complete")

        return results;
    };

    const onDeletePress = async(item) => {
        setBusy(true)
        // await sleep(1500)

        let resutls = await delete_infoPage_Attachment({ variables: { _id: page_id, attachment_id: item._id }})
            .then(r => (r.data.delete_infoPage_Attachment))
            .catch(err=>{
                console.log(__error("Error: "), err);
                return { error:{message:"Query Error!"}}
            })
        if (resutls.error) {
            message.error(resutls.error.message);
            setBusy(false);
            return;
        }

        let arr = attachmentsArray.filter(o => o._id !== item._id)
        set_attachmentsArray(arr);

        setBusy(false)
    }


    return (<>
        {verifyRole('site-docs.manage') &&
            <FormComponent onSubmit={onSubmit} id='InfoPageAttachment' debug={false}
                mutators={{
                    ...arrayMutators,
                    selectFiles: (newValueArray, state, tools) => {
                        let file = newValueArray[0];
                        let action = newValueArray[1];
                        let fileList = state.formState.values.fileList || []
                        if (fileList.length >= FILE_LIMIT) return;

                        if (action == 'add') fileList.push(file);
                        if (action == 'remove') fileList = fileList.filter(o => o.uid != file.uid);

                        tools.changeValue(state, 'fileList', () => fileList);
                    },
                    removeFiles: (newValueArray, state, tools) => {
                        tools.changeValue(state, 'fileList', () => []);
                    },
                }}

                form_render={formProps => {
                    const { values, form, invalid, submitting, dirty, valid } = formProps;

                    return (<Card bodyStyle={{ padding:'10px' }}>

                        <Row>
                            <Col flex="auto">
                                <Upload
                                    itemRender={(originNode, file, fileList, actions) => {
                                        var { download, preview, remove } = actions;
                                        return <div className='upload-list'>{originNode}</div>
                                    }}
                                    onRemove={(file) => form.mutators.selectFiles(file, "remove")}
                                    beforeUpload={(file) => {
                                        form.mutators.selectFiles(file, "add");
                                        return false;
                                    }}
                                    fileList={values.fileList}
                                    accept=".jpeg,.jpg,.png,.pdf"
                                    multiple={true}
                                    maxCount={6}
                                >
                                    <Button size='small' type="default" style={{ marginLeft: "0px" }} disabled={values?.fileList?.length >= 6 ? true : false}><Icon icon="paperclip" style={{ marginRight: '10px' }} /> Select files to attach</Button>
                                </Upload>
                            </Col>
                            <Col><Button type="primary" size="small" htmlType='submit' loading={submitting} disabled={!dirty || !valid}>Upload</Button></Col>
                        </Row>

                        <FieldArray name="fileList">{({ fields }) => null }</FieldArray>

                    </Card>)
                }}
            />
        }

        <Space direction='horizontal' wrap>
            {attachmentsArray && attachmentsArray.map((o, i) => {
                let temp = o.srcUrl.split(".");
                let ext = temp[temp.length - 1];

                let isImg = (['jpeg', 'jpg', 'gif', 'png'].indexOf(ext) > -1);
                let isPdf = (['pdf'].indexOf(ext) > -1);
                let isWord = (['doc', 'docx'].indexOf(ext) > -1);

                let icon = <Icon icon="file" />;
                if (isPdf) icon = <span style={{ fontSize: "18px", marginRight: "5px" }}><Icon icon="file-pdf" color="#000" /></span>
                else if (isWord) icon = <span style={{ fontSize: "18px", marginRight: "5px" }}><Icon icon="file-word" /></span>
                else if (!isImg) icon = <span style={{ fontSize: "18px", marginRight: "5px" }}><Icon icon="file" /></span>

                let path = `${process.env.REACT_APP_DATA_URL}/${o.srcUrl}`;

                return <div key={i} style={{ border: '1px solid #EEE' }}>
                    <Tooltip title={o.title}>
                        <div>
                            {isImg && <Image src={path} height={85} width={85} fallback={img_fallback} />}
                            {!isImg && <a href={path} target="_blank" rel="noreferrer">{<>{icon} {o.title}</>}</a>}
                        </div>
                        {verifyRole('site-docs.manage') &&
                            <div align="center" style={{ backgroundColor: "#999" }}><DeleteButton busy={busy} onClick={()=>onDeletePress(o)} /></div>
                        }
                    </Tooltip>
                </div>

            })}
        </Space>

    </>)
}
